var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUpgradePro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 7.9974C14.6663 4.3155 11.6816 1.33073 7.99967 1.33073C4.31778 1.33073 1.33301 4.3155 1.33301 7.9974C1.33301 11.6793 4.31778 14.6641 7.99967 14.6641C11.6816 14.6641 14.6663 11.6793 14.6663 7.9974Z",
    stroke: "#CECDFF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5762 5.14546L9.16281 6.32835C9.2428 6.49302 9.45611 6.65096 9.63609 6.68121L10.6993 6.85931C11.3792 6.97357 11.5392 7.47093 11.0493 7.96156L10.2227 8.79497C10.0827 8.93611 10.006 9.20831 10.0494 9.40322L10.286 10.4349C10.4727 11.2515 10.0427 11.5674 9.32612 11.1406L8.32956 10.5458C8.14958 10.4383 7.85295 10.4383 7.66964 10.5458L6.67308 11.1406C5.95983 11.5674 5.52654 11.2481 5.71319 10.4349L5.94983 9.40322C5.99316 9.20831 5.9165 8.93611 5.77651 8.79497L4.94994 7.96156C4.46333 7.47093 4.61998 6.97357 5.2999 6.85931L6.36312 6.68121C6.53976 6.65096 6.75307 6.49302 6.83306 6.32835L7.41967 5.14546C7.73963 4.5036 8.25957 4.5036 8.5762 5.14546Z",
    stroke: "#CECDFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpgradePro);
export default __webpack_public_path__ + "static/media/icon-upgrade-pro.1cd44f99ec0d25461e0a232e70793179.svg";
export { ForwardRef as ReactComponent };